<template>
    <div class="content">
        <div class="left">
            <img src="../assets/images/icon.png" alt="" />
            {{ titleName }}
        </div>
        <div class="right" @click="popupFlag = !popupFlag">
            <img
                src="../assets/images/logo.png"
                alt=""
                v-if="!userInfoMsg.head"
            />
            <img :src="userInfoMsg.head" alt="" v-if="userInfoMsg.head" />
            <!-- <img
                :src="
                    userInfoMsg.head != null
                        ? userInfoMsg.head
                        : '../assets/images/logo.png'
                "
                alt=""
            /> -->
            <div class="rightName">{{ userInfoMsg.nickName || '' }}</div>
            <i class="el-icon-caret-bottom"></i>
        </div>

        <div class="contBox" v-if="popupFlag">
            <div class="contLi" @click="toUrl('/modifiedData')">
                <img src="../assets/images/cjwt.png" alt="" />
                <div class="contLiName">修改资料</div>
            </div>
            <div class="contLi" @click="toUrl('/commonProblem')">
                <img src="../assets/images/cjwt.png" alt="" />
                <div class="contLiName">常见问题</div>
            </div>
            <div class="contLi" @click="toUrl('/sendFeedback')">
                <img src="../assets/images/fsfk.png" alt="" />
                <div class="contLiName">发送反馈</div>
            </div>
            <div class="contLi" @click="toUrl('/aboutPage')">
                <img src="../assets/images/gy.png" alt="" />
                <div class="contLiName">关于</div>
            </div>
            <div class="contLi" @click="toUrl('/changePassword')">
                <img src="../assets/images/gy.png" alt="" />
                <div class="contLiName">修改密码</div>
            </div>
            <div class="contLi" @click="goOut">
                <img src="../assets/images/jiantou.png" alt="" />
                <div class="contLiName">退出</div>
            </div>
        </div>
    </div>
</template>

<script>
import { userInfo } from '@/api/index'
export default {
    data() {
        return {
            popupFlag: false,
            titleName: '发送',
            userInfoMsg: {}
        }
    },
    watch: {
        $route(to) {
            // 监听路由变化，根据需要调整showFooter的值
            console.log(to.name)
            if (to.name == 'home') {
                this.titleName = '发送'
            } else if (to.name == 'transferPage') {
                this.titleName = '接收'
            } else if (to.name == 'transmitPage') {
                this.titleName = '传输'
            } else if (to.name == 'commonProblem') {
                this.titleName = '常见问题'
            } else if (to.name == 'sendFeedback') {
                this.titleName = '发送反馈'
            } else if (to.name == 'aboutPage') {
                this.titleName = '关于'
            } else if (to.name == 'changePassword') {
                this.titleName = '修改密码'
            } else if (to.name == 'modifiedData') {
                this.titleName = '修改资料'
            }
        }
    },

    created() {
        this.getUser()
    },
    methods: {
        getUser() {
            userInfo().then((res) => {
                console.log(res)
                if (res.code == 0) {
                    this.userInfoMsg = res.data
                    localStorage.setItem('userInfo', JSON.stringify(res.data))
                }
            })
        },
        // 退出登录
        goOut() {
            // localStorage.clear()
            localStorage.removeItem('token')

            this.$router.replace('/')
        },
        toUrl(urlSrc) {
            this.popupFlag = false
            this.$router.push({ path: urlSrc })
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    flex: 1;
    height: 77px;
    display: flex;

    align-items: center;
    justify-content: space-between;
    padding: 0 26px 0 24px;
    box-sizing: border-box;
    border-bottom: 1px solid #ecedfc;
    position: relative;
}
.left {
    color: #1d1d1d;
    font-size: 14px;
    font-weight: 500;
    font-family: 'HarmonyOSSansSC';

    display: flex;

    align-items: center;
    img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
    }
}

.right {
    display: flex;
    align-items: center;
    img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
    .rightName {
        color: #000000;
        font-size: 14px;
        font-weight: 500;
        font-family: 'HarmonyOSSansSC';
        margin-left: 3px;
    }
}
.contBox {
    position: absolute;
    top: 80px;
    right: 0;
    width: 317px;
    border-radius: 14.02px;
    background: #ffffff;
    box-shadow: 0 7.59px 30.38px 0 #bcc9e380;
    z-index: 999999999;

    .contLi {
        display: flex;
        align-items: center;
        padding: 20px;
        box-sizing: border-box;
        img {
            width: 15px;
            height: 15px;
            margin-right: 12px;
        }
        .contLiName {
            color: #000000;
            font-size: 14px;
            font-weight: 400;
            font-family: 'HarmonyOSSansSC';
        }
    }
}
@media screen and (max-width: 768px) {
    .content {
        height: 60px !important;
        padding: 0 15px !important;
        box-sizing: border-box;

        .left {
            font-size: 16px !important; /* 增大标题字号 */
            img {
                width: 20px !important;
                height: 20px !important;
                margin-right: 8px !important;
            }
        }

        .right {
            img {
                width: 32px !important;
                height: 32px !important; /* 缩小头像尺寸 */
            }
            .rightName {
                display: none; /* 小屏隐藏用户名 */
            }
            i {
                font-size: 14px; /* 缩小图标 */
            }
        }

        .contBox {
            width: 200px !important; /* 缩小弹出菜单宽度 */
            top: 65px !important;
            right: 10px !important;

            .contLi {
                padding: 12px 15px !important; /* 减小内边距 */
                img {
                    width: 14px !important;
                    height: 14px !important;
                    margin-right: 8px !important;
                }
                .contLiName {
                    font-size: 13px !important; /* 减小字体 */
                }
            }
        }
    }
}
</style>